
const lastUpdate = '2026-03-15';
export const helpTitle = 'Duty Log Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Duty Log Explorer is the daily operational record for fire management. Use it to create, review, and approve duty log entries, and to generate official reports.</p>

<h2>Creating and Editing Entries</h2>
<ul>
  <li>Click <strong>New Entry</strong> to create a duty log entry for today.</li>
  <li>Click any existing entry to open and edit it.</li>
  <li>Entries must be <strong>approved</strong> before they appear in official exports.</li>
</ul>

<h2>Filtering</h2>
<ul>
  <li><strong>Date</strong> — View entries for a specific day or range.</li>
  <li><strong>Author</strong> — Filter by the officer who created the entry.</li>
  <li><strong>Status</strong> — Show draft, submitted, or approved entries.</li>
</ul>

<h2>Exporting</h2>
<p>Three export formats are available:</p>
<ul>
  <li><strong>CSV</strong> — Tabular data for spreadsheet analysis.</li>
  <li><strong>PDF Logbook</strong> — Formatted logbook layout for printing.</li>
  <li><strong>PDF Legal</strong> — Legally formatted document for official records.</li>
</ul>

<h2>Audit Trail</h2>
<p>Every change to a duty log entry is recorded — who made the change, when, and what was modified. This ensures full accountability for the official record.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
